<template>
  <div v-if="isShow" :id="'AddProductModal' + name">
    <b-modal
      v-model="isShow"
      id="addproduct-modal"
      ref="addproduct-modal"
      class="p-0"
      size="lg"
      hide-header
      hide-footer
      centered
    >
      <div class="header-purple">
        <p class="font-weight-bold mb-0">รายการเพิ่มสินค้า</p>
      </div>
      <div class="container-list-">
        <b-container class="px-0">
          <div class="d-flex flex-row no-gutters">
            <b-input-group class="panel-input-serach">
              <b-form-input
                class="input-serach"
                placeholder="ค้นหาชื่อสินค้า, SKU, คอลเลคชั่นสินค้า"
                v-model="filterList.search"
                :id="'' + name + 'AddProductSearch'"
                v-on:keyup.13="enterFilter"
              ></b-form-input>
              <b-input-group-prepend>
                <span class="icon-input m-auto pr-2">
                  <font-awesome-icon icon="search" title="View" />
                </span>
              </b-input-group-prepend>
            </b-input-group>
            <div>
              <FilterAddProduct
                :name="'AddProduct' + name"
                v-on:onSubmitFilter="onSubmitFilter"
                ref="filterAddProduct"
              />
            </div>
          </div>

          <b-row class="no-gutters my-3">
            <b-col md="4"> รายการสินค้า </b-col>
            <b-col class="text-md-right mt-2 mt-md-0 text-black-50" md="8">
              แสดงผลลัพธ์ {{ items.length }} รายการ
            </b-col>
          </b-row>
          <div class="list-">
            <b-table
              class="text-center table-list mb-0 bg-white"
              responsive
              :items="items"
              :fields="fields"
              :busy="isBusy"
              show-empty
              empty-text="ไม่พบข้อมูล"
              thead-class="d-none"
            >
              <template #cell(productId)="data">
                <div>
                  <b-form-checkbox
                    :id="'addProduct' + name + 'Checkbox' + data.item.id"
                    name="productCb"
                    :value="data.item.id"
                    v-model="listIdSelected"
                    :disabled="data.item.stockStatus == 'หมด'"
                    @change="checkProduct(data.item)"
                  ></b-form-checkbox>
                  <!-- @change="checkProduct(data.item)" -->
                </div>
              </template>

              <template #cell(imageUrl)="data">
                <div>
                  <div class="position-relative picture-text">
                    <div
                      class="square-box b-contain"
                      v-bind:style="{
                        'background-image': 'url(' + data.item.imageUrl + ')',
                      }"
                    ></div>
                  </div>
                </div>
              </template>

              <template #cell(name)="data">
                <div class="text-left align-middle">
                  <p class="mb-0">{{ data.item.sku }}</p>
                  <p class="text-black-50 mb-0">{{ data.item.name }}</p>
                  <b-badge
                    v-if="data.item.stockStatus == 'หมด'"
                    pill
                    variant="danger"
                    class="px-3 text-white"
                    >หมด</b-badge
                  >
                  <b-badge
                    v-if="data.item.stockStatus == 'เหลือน้อย'"
                    pill
                    variant="warning"
                    class="px-3 text-white"
                    >เหลือน้อย</b-badge
                  >
                </div>
              </template>
              <template v-slot:cell(price)="data">
                <p class="m-0 price-text" v-if="data.item.price">
                  ฿ {{ data.item.price | numeral("0,0.00") }}
                </p>
                <p v-else class="m-0 price-text">-</p>
              </template>
            </b-table>
          </div>
        </b-container>
      </div>
      <b-row class="no-gutters px-3 px-sm-0 bg-white" v-if="!isBusy">
        <b-col
          class="form-inline justify-content-center justify-content-sm-end"
        >
          <div class="d-sm-flex m-3">
            <b-pagination
              v-model="filterList.pageNo"
              :total-rows="rows"
              :per-page="filterList.perPage"
              class="m-md-0 page-item"
              @change="pagination"
            ></b-pagination>
          </div>
          <b-form-select
            class="mr-sm-3 select-page"
            v-model="filterList.perPage"
            @change="handleChangePerpage"
            :options="pageOptions"
          ></b-form-select>
        </b-col>
      </b-row>
      <div class="container-footer">
        <b-button
          class="btn-main-2"
          @click="closeModal"
          :id="'cancleAddProduct' + name"
          >ยกเลิก</b-button
        >
        <b-button
          class="btn-main"
          @click="addProduct"
          :id="'saveAddProduct' + name"
          >เพิ่มสินค้า</b-button
        >
      </div>
    </b-modal>
  </div>
</template>

<script>
import FilterAddProduct from "./../filter/FilterAddProduct.vue";

export default {
  components: {
    FilterAddProduct,
  },
  props: {
    name: {
      required: false,
      type: String,
    },
    listId: {
      required: false,
      type: Array,
    },
  },
  data: function () {
    return {
      isShow: false,
      items: [],
      fields: [
        {
          key: "productId",
          label: "",
          class: "w-40px text-nowrap",
        },
        {
          key: "imageUrl",
          label: "",
          class: "w-70px text-nowrap",
        },
        {
          key: "name",
          label: "",
          class: "w-100px text-nowrap",
        },
        {
          key: "price",
          label: "",
          class: "w-100px text-nowrap text-left",
        },
      ],
      productSelected: [],
      rows: 0,
      isBusy: false,
      filterList: {
        search: "",
        productTypes: [],
        productStatus: [],
        categories: [0, 0, 0, 0],
        stockStatus: [3],
        pageNo: 1,
        perPage: 10,
        collections: "",
        selectTab: 0,
        stockStatusId: 3
      },
      rows: 0,
      pageOptions: [
        { value: 10, text: "10 / หน้า" },
        { value: 30, text: "30 / หน้า" },
        { value: 50, text: "50 / หน้า" },
        { value: 100, text: "100 / หน้า" },
      ],
      listIdSelected: [],
    };
  },
  async created() {
    this.getProductList();
  },
  watch: {
    isShow: function () {
      if (this.isShow) {
        this.listIdSelected = this.listId;
      }
    },
  },
  methods: {
    addProduct() {
      this.$emit("add-product", this.productSelected, this.listIdSelected);
      this.closeModal();
      this.productSelected = [];
    },
    checkProduct(item) {
      const index = this.productSelected.indexOf(item);
      if (index > -1) {
        this.productSelected.splice(index, 1);
      } else {
        this.productSelected.push(item);
      }
      // console.log(JSON.stringify(this.productSelected));
    },
    closeModal() {
      this.isShow = false;
    },
    openModal() {
      this.isShow = true;
    },
    unCheckProduct(listIdDelete) {
      for (let x in listIdDelete) {
        if (this.listIdSelected.includes(listIdDelete[x])) {
          let index = this.listIdSelected.indexOf(listIdDelete[x]);
          if (index != -1) {
            this.listIdSelected.splice(index, 1);
          }
        }
      }
    },
    onSubmitFilter(filter) {
      this.getProductList(filter);
    },
    getProductList(filter) {
      if (filter) {
        this.filterList.search = filter.search;
        this.filterList.productTypes = filter.productTypes;
        this.filterList.productStatus = filter.productStatus;
        this.filterList.categories = filter.categories;
        this.filterList.stockStatus = filter.stockStatus;
        this.filterList.perPage = filter.perPage;
        this.filterList.pageNo = filter.pageNo;
        this.filterList.collections = filter.collections;
        this.filterList.selectTab = 0;
        this.filterList.stockStatusId = this.filterList.stockStatus[0] || 3;
      }

      this.isBusy = true;
      this.axios
        .post(`${this.$baseUrl}/product/search`, this.filterList)
        .then((data) => {
          this.rows = data.detail.countTotal;
          this.items = data.detail.dataList;
          this.isBusy = false;
        });
    },
    enterFilter(event) {
      console.log(`event`, event);
      if (event.which === 13) {
        this.getProductList();
      }
    },
    handleChangePerpage(value) {
      this.filterList.pageNo = 1;
      this.filterList.perPage = value;
      this.getProductList();
    },
    pagination(pageNo) {
      this.filterList.pageNo = pageNo;
      this.getProductList();
    },
  },
};
</script>

<style lang="scss" scoped>
.list- {
  border: 1px solid #bcbcbc;
  padding-left: 8px;
  padding-right: 8px;
  border-radius: 8px;
  overflow-y: scroll;
  height: 40vh;
}
.container-list- {
  padding: 1rem 1rem 0rem 1rem;
}
.container-footer {
  padding: 0rem 1rem 1rem 1rem;
  display: flex;
  justify-content: space-between;
}
.list-item {
  padding: 8px;
}

.list-item:not(:last-child) {
  border-bottom: 1px solid #bcbcbc;
}

.img-container {
  width: 80px;
  height: 80px;
}

.btn-filter-custom {
  background-color: white !important;
  color: #5b57a5 !important;
  width: 100%;
  white-space: nowrap;
  border-color: #5b57a5 !important;
}

.btn-filter-custom:hover {
  border-color: #5b57a5 !important;
}
/deep/ .table td {
  border-bottom: 0.5px solid #ccc !important;
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important;
}
.picture-text {
  min-width: 80px;
}
</style>
